import { nextSort, readSort, SORT_LABELS, withParams, type SortColumn } from '../lib/listSort';

/**
 * En-têtes de colonne de la liste, cliquables pour trier (côté API). Même
 * grille que TicketRow ; masqués sur écran étroit (menu « Trier par »).
 */
export function TicketListHeader({ params, setParams }: { params: URLSearchParams; setParams: (next: URLSearchParams) => void }) {
  const current = readSort(params);

  const SortButton = ({ col, label }: { col: SortColumn; label?: string }) => {
    const on = current.sort === col;
    const arrow = on ? (current.dir === 'asc' ? '▲' : '▼') : '';
    const text = label ?? SORT_LABELS[col];
    return (
      <button
        type="button"
        className={`trow-sort${on ? ' is-on' : ''}`}
        aria-label={`Trier par ${text.toLowerCase()}${on ? (current.dir === 'asc' ? ', croissant' : ', décroissant') : ''}`}
        onClick={() => {
          const n = nextSort(current, col);
          setParams(withParams(params, { sort: n.sort, dir: n.dir }));
        }}
      >
        {text}
        <span aria-hidden="true" className="trow-sort-arrow">
          {arrow}
        </span>
      </button>
    );
  };

  return (
    <div className="trow-c">
      <div className="trow trow-head">
        <div className="trow-id">
          <SortButton col="id" />
        </div>
        <div className="trow-type">
          <SortButton col="type" label="Type" />
        </div>
        <div className="trow-prio">
          <SortButton col="priorite" label="Prio." />
          <SortButton col="etat" />
        </div>
        <div className="trow-date">
          <SortButton col="date" />
        </div>
        <div className="trow-logo" />
        <div className="trow-client">
          <SortButton col="client" />
        </div>
        <div className="trow-subject">Sujet</div>
        <div className="trow-people">Traitants</div>
      </div>
    </div>
  );
}
